const DEMO_MODE_KEY = 'anforderungsai:demoMode';
const DEMO_SESSION_ID_KEY = 'anforderungsai:demoSessionId';
export const DEMO_TOKEN_KEY = 'anforderungsai.demoAuthToken';
export const DEMO_STATE_KEY = 'anforderungsai:demoState:v1';

let inMemoryDemoMode = false;
let inMemorySessionId = null;

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

const createId = () => {
  try {
    if (globalThis.crypto?.randomUUID) {
      return globalThis.crypto.randomUUID();
    }
  } catch {
    // ignore
  }
  return `demo_${Date.now()}_${Math.random().toString(16).slice(2)}`;
};

export const isDemoMode = () => {
  const storage = getSessionStorage();
  if (storage) {
    return storage.getItem(DEMO_MODE_KEY) === '1';
  }
  return inMemoryDemoMode;
};

export const getDemoSessionId = () => {
  const storage = getSessionStorage();
  if (storage) {
    return storage.getItem(DEMO_SESSION_ID_KEY) ?? null;
  }
  return inMemorySessionId;
};

export const enableDemoMode = () => {
  const storage = getSessionStorage();
  const sessionId = createId();
  if (!storage) {
    inMemoryDemoMode = true;
    inMemorySessionId = inMemorySessionId ?? sessionId;
    return true;
  }
  storage.setItem(DEMO_MODE_KEY, '1');
  if (!storage.getItem(DEMO_SESSION_ID_KEY)) {
    storage.setItem(DEMO_SESSION_ID_KEY, sessionId);
  }
  return true;
};

export const disableDemoMode = () => {
  const storage = getSessionStorage();
  inMemoryDemoMode = false;
  inMemorySessionId = null;
  if (!storage) return;
  storage.removeItem(DEMO_MODE_KEY);
  storage.removeItem(DEMO_SESSION_ID_KEY);
  storage.removeItem(DEMO_STATE_KEY);
  storage.removeItem(DEMO_TOKEN_KEY);
};
